export default "__VITE_ASSET__BV7iR0DZ__"